"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetStagingStatus = void 0;
var DatasetStagingStatus;
(function (DatasetStagingStatus) {
    DatasetStagingStatus["Pending"] = "pending";
    DatasetStagingStatus["InProgress"] = "in_progress";
    DatasetStagingStatus["Completed"] = "completed";
    DatasetStagingStatus["Failed"] = "failed";
    DatasetStagingStatus["Cancelled"] = "cancelled";
})(DatasetStagingStatus || (exports.DatasetStagingStatus = DatasetStagingStatus = {}));
